// extracted by mini-css-extract-plugin
module.exports = {"label":"G_cl","text":"G_by"};